import { axiosInstanceV3 } from '../common/instance';
import { SummariesDataRequest } from '../dashboard/types';

export const exportKioskV3Service = async (params?: SummariesDataRequest)
  : Promise<{ link: string }> => {
  const res = await axiosInstanceV3.get('report-exports/export-kiosk', { params });
  return res.data.data;
};

export const exportKioskSurveyV3Service = async (params?: SummariesDataRequest)
  : Promise<{ link: string }> => {
  const res = await axiosInstanceV3.get('report-exports/export-kiosk-survey', { params });
  return res.data.data;
};

export const exportKioskTotalSurveyV3Service = async (params?: SummariesDataRequest)
  : Promise<{ link: string }> => {
  const res = await axiosInstanceV3.get('report-exports/export-total-kiosk-survey', { params });
  return res.data.data;
};

export const exportKioskTotalSurveyByMonthV3Service = async (params?: SummariesDataRequest)
  : Promise<{ link: string }> => {
  const res = await axiosInstanceV3.get('report-exports/export-total-kiosk-survey-by-month', { params });
  return res.data.data;
};

export const exportKioskWorkingV3Service = async ()
  : Promise<{ link: string }> => {
  const res = await axiosInstanceV3.get('report-exports/export-kiosk-working');
  return res.data.data;
};
